import { onUnmounted, onUpdated, ref, watch } from '@vue/composition-api';
import { useFeatureFlags } from './feature-flags';
import { isNil } from 'ramda';
import { S } from '../utilities';

export default function useQAMode() {
    const { flag } = useFeatureFlags();
    const createdElements = ref<string[]>([]);
    const visible = ref<boolean>(false);
    const isQAModeEnabled = flag('qa-mode');
    const isMacOS = S.isMacOS();
    const attribute = 'data-testid';
    const shortcut = 'M';
    const qaModeStyle = `qamode-style`;
    const qaModeClass = `qamode-${attribute}`;

    const setElementStyle = () => {
        const dataIdStyle = document.createElement('style');
        dataIdStyle.appendChild(document.createTextNode(`[${attribute}] { border: purple 2px solid; } `));
        dataIdStyle.id = qaModeStyle;
        dataIdStyle.setAttribute('type', 'text/css');
        document.head.appendChild(dataIdStyle);
    };

    const addIndicator = () => {
        const indicator = document.createElement('div');
        indicator.appendChild(document.createTextNode('QA MODE ON'));
        indicator.setAttribute('class', `${qaModeClass} absolute rounded p-4 animate-pulse`);
        indicator.setAttribute('style', `background-color: purple; color: white; top: 5px; left:5px; z-index: 100;`);
        document.body.appendChild(indicator);
    };

    const show = () => {
        const elements = document.querySelectorAll(`[${attribute}]`);
        setElementStyle();
        addIndicator();
        for (let e = 0; e < elements.length; e++) {
            const element = elements[e];

            const testid = element.getAttribute(attribute);
            if (!isNil(testid) && (element as any).checkVisibility() && !createdElements.value.includes(testid)) {
                const rect = element.getBoundingClientRect();
                const newDiv = document.createElement('div');
                newDiv.appendChild(document.createTextNode(testid));

                newDiv.setAttribute('class', `${qaModeClass} absolute text-xs rounded px-2 py-1`);
                const horizontal =
                    document.body.scrollWidth < rect.x
                        ? `left: ${rect.x}px;`
                        : `right: ${document.body.scrollWidth - rect.x}px`;
                const vertical =
                    document.body.scrollHeight < rect.y
                        ? `top: ${rect.y}px;`
                        : `bottom: ${document.body.scrollHeight - rect.y}px`;
                newDiv.setAttribute('style', `background-color: purple; color: white; ${vertical}; ${horizontal};`);
                document.body.appendChild(newDiv);

                createdElements.value.push(testid);
            }
        }
    };
    const hide = () => {
        document.getElementById(qaModeStyle)?.remove();
        const elements = document.querySelectorAll(`.${qaModeClass}`);
        for (let e = 0; e < elements.length; e++) {
            elements[e].remove();
        }
        createdElements.value = [];
    };

    if (isQAModeEnabled) {
        document.addEventListener('keydown', (e) => {
            if (
                e.key &&
                ((e.key.toLowerCase() === shortcut.toLowerCase() && e.metaKey && isMacOS) ||
                    (e.key.toLowerCase() === shortcut.toLowerCase() && e.ctrlKey && !isMacOS))
            ) {
                visible.value = !visible.value;
                e.preventDefault();
                e.stopPropagation();
            }
        });

        watch(
            () => visible.value,
            (isVisible: boolean) => {
                if (isVisible) show();
                else hide();
            },
        );

        onUpdated(() => {
            hide();
            setTimeout(() => {
                if (visible.value) show();
            }, 2000);
        });

        onUnmounted(() => {
            hide();
        });
    }
}
